import { useQuery } from "@tanstack/react-query";
import { getLoanRepayments } from "data/loanRouterSubgraph";

import { Loan } from "./data/types";

export function usePaymentHistory(loan: Loan) {
  return useQuery({
    queryKey: ["paymentHistory", loan.loanTermsHash] as const,
    queryFn: async () => {
      return await getLoanRepayments({
        chainId: loan.chainId,
        loanTermsHash: loan.loanTermsHash,
        deadlines: loan.loanState.deadlines,
      });
    },
  });
}
